/* ═══════════════════════════════════════════════════════════════
   HOUSE OF RAJATVA · shell controller
   Overlays · scroll lock · cart (AJAX API) · wishlist (localStorage)
   No dependencies. Load with `defer`.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Shopify.routes can be absent on some templates — never let that
     silently turn every fetch into "undefinedcart.js". */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(paise) {
    return '\u20B9' + Math.round(paise / 100).toLocaleString('en-IN');
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  /* Shopify CDN resize by query parameter. cart.js returns
     ".../file.jpg?v=123", so the legacy _WxH.jpg form never resolves. */
  function cdn(url, w, h) {
    if (!url) return '';
    var parts = String(url).split('?');
    var q;
    try { q = new URLSearchParams(parts[1] || ''); } catch (e) { return url; }
    q.set('width', w);
    if (h) { q.set('height', h); q.set('crop', 'center'); }
    return parts[0] + '?' + q.toString();
  }
  function ph(w, h) {
    return '<span class="hor-ph" style="width:100%;height:100%;aspect-ratio:' +
      w + '/' + h + '" aria-hidden="true"></span>';
  }

  /* ─────────────────────────────────────────────────────────
     OVERLAYS — one open at a time, page locked behind it
     ───────────────────────────────────────────────────────── */
  var Overlay = {
    current: null, scrollY: 0,

    lock: function () {
      this.scrollY = window.scrollY;
      document.body.style.top = '-' + this.scrollY + 'px';
      document.body.classList.add('hor-locked');
    },
    unlock: function () {
      document.body.classList.remove('hor-locked');
      document.body.style.top = '';
      window.scrollTo(0, this.scrollY);
    },
    close: function () {
      if (!this.current) return;
      var el = $('#hor-' + this.current);
      if (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); }
      var s = $('#hor-scrim'); if (s) s.classList.remove('is-open');
      this.unlock();
      this.current = null;
      this.sync();
    },
    open: function (id, opts) {
      opts = opts || {};
      if (this.current === id) { this.close(); return; }
      var el = $('#hor-' + id);
      if (!el) return;
      if (this.current) {
        var prev = $('#hor-' + this.current);
        if (prev) { prev.classList.remove('is-open'); prev.setAttribute('aria-hidden', 'true'); }
      } else {
        this.lock();
      }
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      var s = $('#hor-scrim'); if (s) s.classList.add('is-open');
      this.current = id;
      this.sync();

      /* focus the search field only when the search icon asked for it */
      if (opts.focusSearch) {
        var f = el.querySelector('[data-hor-search-input]');
        if (f) setTimeout(function () { f.focus(); }, 360);
      }
      if (id === 'cart') Cart.fetch();
      if (id === 'wish') Wish.render();
    },
    sync: function () {
      var cur = this.current;
      $$('[data-hor-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', b.dataset.horOpen === cur ? 'true' : 'false');
      });
      var home = $('[data-hor-home]');
      if (home) home.classList.toggle('is-active', !cur);
    }
  };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hor-open]');
    if (t) {
      e.preventDefault();
      Overlay.open(t.dataset.horOpen, { focusSearch: t.hasAttribute('data-hor-focus-search') });
      return;
    }
    if (e.target.closest('[data-hor-close]')) { e.preventDefault(); Overlay.close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') Overlay.close();
  });

  /* ── toast ──────────────────────────────────────────────── */
  var toastTimer;
  function toast(msg) {
    var t = $('#hor-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-open'); }, 2200);
  }

  /* ─────────────────────────────────────────────────────────
     CART
     ───────────────────────────────────────────────────────── */
  var Cart = {
    state: null, mov: 0, scope: 'swanqii', ups: [],

    init: function () {
      var root = $('#hor-cart');
      if (!root) return;
      this.mov = parseInt(root.dataset.mov || '0', 10);
      this.scope = root.dataset.movScope || 'swanqii';
      var feed = $('#hor-ups-data');
      if (feed) {
        try { this.ups = JSON.parse(feed.textContent) || []; }
        catch (err) { this.ups = []; console.warn('[HOR] upsell JSON invalid', err); }
      }
      this.fetch();
    },

    fetch: function () {
      var self = this;
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.state = c; self.render(); return c; })
        .catch(function (err) { console.warn('[HOR] cart fetch failed', err); });
    },

    add: function (payload, qty, house) {
      var self = this, body, headers = { Accept: 'application/json' };
      if (payload instanceof FormData) {
        body = payload;                       /* never set Content-Type for FormData */
      } else {
        headers['Content-Type'] = 'application/json';
        var line = { id: Number(payload), quantity: qty || 1 };
        /* cart.js never returns product tags, so the house has to travel with
           the line as a property. Leading underscore hides it at checkout. */
        if (house) line.properties = { _house: house };
        body = JSON.stringify({ items: [line] });
      }
      return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: headers, body: body })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.d.description || res.d.message || 'Could not add that'); return; }
          return self.fetch().then(function () { Overlay.open('cart'); });
        })
        .catch(function () { toast('Network error \u2014 try again'); });
    },

    change: function (key, qty) {
      var self = this;
      return fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.state = c; self.render(); })
        .catch(function () { toast('Network error \u2014 try again'); });
    },

    /* Which house a line belongs to.
       cart.js returns NO product tags, so we resolve in this order:
         1. the _house line property our own add flow attaches
         2. the upsell feed, which maps product_id to house
         3. vendor or product_type, if either is named after a house
         4. rajatva */
    houseOf: function (item) {
      if (item.properties && item.properties._house) return item.properties._house;

      for (var i = 0; i < this.ups.length; i++) {
        if (this.ups[i].pid === item.product_id) return this.ups[i].house;
      }
      var hay = ((item.vendor || '') + ' ' + (item.product_type || '')).toLowerCase();
      if (hay.indexOf('swanqii') !== -1) return 'swanqii';
      if (hay.indexOf('rajatva') !== -1) return 'rajatva';
      return 'rajatva';
    },

    render: function () {
      var c = this.state;
      if (!c) return;

      $$('[data-hor-count]').forEach(function (b) {
        b.textContent = c.item_count;
        b.style.display = c.item_count ? 'grid' : 'none';
      });

      var self = this;
      var lines = $('#hor-cart-lines');
      if (lines) {
        lines.innerHTML = c.items.length ? c.items.map(function (i) {
          var raw = i.image || (i.featured_image && i.featured_image.url) || '';
          var im = cdn(raw, 162, 204);
          var house = self.houseOf(i);
          var label = house === 'swanqii' ? 'SWANQII \u00B7 AU / 316L' : 'RAJATVA \u00B7 AG 925';
          var variant = (i.variant_title && i.variant_title !== 'Default Title')
            ? ' \u00B7 ' + esc(i.variant_title) : '';
          return '<div class="hor-li" data-house-line="' + house + '">' +
            '<div class="hor-li__im">' +
              (im ? '<img src="' + im + '" alt="" width="54" height="68" loading="lazy" decoding="async">' : ph(54, 68)) +
            '</div><div class="hor-li__m">' +
              '<h5>' + esc(i.product_title) + '</h5>' +
              '<div class="hor-li__hs">' + label + variant + '</div>' +
              '<div class="hor-li__r"><div class="hor-qty">' +
                '<button type="button" data-hor-qty="' + i.key + '" data-hor-to="' + (i.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
                '<span>' + i.quantity + '</span>' +
                '<button type="button" data-hor-qty="' + i.key + '" data-hor-to="' + (i.quantity + 1) + '" aria-label="Increase">+</button>' +
              '</div>' +
              '<button type="button" class="hor-li__x" data-hor-linemenu aria-label="Line options">' +
                '<svg class="hor-i" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="5" r="1.4"/><circle cx="12" cy="12" r="1.4"/><circle cx="12" cy="19" r="1.4"/></svg>' +
              '</button>' +
              '<span class="hor-li__pr">' + money(i.final_line_price) + '</span>' +
              '<div class="hor-li__menu">' +
                '<button type="button" data-hor-tofav=\'' + esc(JSON.stringify({
                    pid: i.product_id, vid: i.variant_id, title: i.product_title,
                    price: i.price, img: raw, url: i.url, key: i.key
                  })) + '\'>Move to wishlist</button>' +
                '<button type="button" class="warn" data-hor-drop="' + i.key + '">Remove</button>' +
              '</div>' +
            '</div></div></div>';
        }).join('') : '<div class="hor-empty">Your cart is empty.</div>';
      }

      /* ── minimum order: the CART TOTAL is what counts ──
         A Rajatva piece plus a small SwanQii piece clears it together, which
         is the behaviour you want. The bar only appears while it is unmet. */
      var gap = this.mov - c.total_price;
      var met = this.mov <= 0 || gap <= 0;
      var show = !met && c.item_count > 0;

      var box = $('#hor-mov'), mt = $('#hor-mov-text'), mb = $('#hor-mov-bar');
      if (box) box.hidden = !show;
      if (show && mt) {
        mt.innerHTML = 'Add <b>' + money(gap) + '</b> more to check out ' +
          '<span class="dim">(' + money(this.mov) + ' minimum)</span>';
      }
      if (show && mb) mb.style.width = Math.min(100, (c.total_price / this.mov) * 100) + '%';

      /* ── upsell, sorted by the gap ── */
      var row = $('#hor-ups-row'), wrap = $('#hor-ups');
      if (row) {
        var inCart = c.items.map(function (i) { return i.product_id; });
        var pool = this.ups.filter(function (p) { return inCart.indexOf(p.pid) === -1; });
        pool.sort(function (a, b) {
          return met ? a.price - b.price : Math.abs(a.price - gap) - Math.abs(b.price - gap);
        });
        pool = pool.slice(0, 8);
        if (wrap) wrap.hidden = pool.length === 0;
        row.innerHTML = pool.map(function (p) {
          return '<div class="hor-up">' +
            (p.img ? '<img src="' + cdn(p.img, 300, 375) + '" alt="" width="100" height="125" loading="lazy" decoding="async">' : ph(100, 125)) +
            '<div class="hor-up__u"><div class="hor-up__n">' + esc(p.title) + '</div>' +
            '<div class="hor-up__a"><span class="hor-up__pr">' + money(p.price) + '</span>' +
            '<button type="button" data-hor-add="' + p.vid + '" aria-label="Add ' + esc(p.title) + '">+</button>' +
            '</div></div></div>';
        }).join('');
      }

      var sub = $('#hor-subtotal'), tot = $('#hor-total');
      if (sub) sub.textContent = money(c.total_price);
      if (tot) tot.textContent = money(c.total_price);

      var btn = $('#hor-checkout');
      if (btn) {
        btn.disabled = !met || c.item_count === 0;
        btn.textContent = c.item_count === 0 ? 'Your cart is empty'
          : met ? 'Checkout \u00B7 ' + money(c.total_price)
                : 'Add ' + money(gap) + ' more to check out';
      }
    }
  };

  /* Capture phase runs before Dawn's own handler on the form element, so
     preventDefault + stopPropagation stops its drawer ever initialising. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    Cart.add(new FormData(form)).then(function () {
      if (btn) btn.removeAttribute('aria-busy');
    });
  }, true);

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-hor-qty]');
    if (q) { Cart.change(q.dataset.horQty, parseInt(q.dataset.horTo, 10)); return; }
    var a = e.target.closest('[data-hor-add]');
    if (a) {
      a.disabled = true;
      a.dataset.state = 'loading';
      Cart.add(a.dataset.horAdd, 1, a.dataset.horHouse).then(function () {
        a.dataset.state = 'done';
        a.textContent = '\u2713';
        setTimeout(function () {
          a.dataset.state = '';
          a.textContent = '+';
          a.disabled = false;
        }, 1100);
      });
      return;
    }
    var lm = e.target.closest('[data-hor-linemenu]');
    if (lm) {
      var li = lm.closest('.hor-li'), was = li.classList.contains('is-menu');
      $$('.hor-li.is-menu').forEach(function (x) { x.classList.remove('is-menu'); });
      li.classList.toggle('is-menu', !was);
      return;
    }
    if (!e.target.closest('.hor-li__menu')) {
      $$('.hor-li.is-menu').forEach(function (x) { x.classList.remove('is-menu'); });
    }

    var drop = e.target.closest('[data-hor-drop]');
    if (drop) { Cart.change(drop.dataset.horDrop, 0); return; }

    var fav = e.target.closest('[data-hor-tofav]');
    if (fav) {
      var d;
      try { d = JSON.parse(fav.dataset.horTofav); } catch (err) { return; }
      if (!Wish.has(d.pid)) {
        Wish.items.unshift({ pid: d.pid, vid: d.vid, title: d.title,
                             price: d.price, img: d.img, url: d.url });
        Wish.save(); Wish.render(); Wish.syncHearts();
      }
      Cart.change(d.key, 0);
      toast('Moved to wishlist');
      return;
    }

    var co = e.target.closest('#hor-checkout');
    if (co && !co.disabled) { window.location.href = ROOT + 'checkout'; }
  });

  /* ─────────────────────────────────────────────────────────
     WISHLIST — localStorage. Account sync needs an app proxy.
     ───────────────────────────────────────────────────────── */
  var KEY = 'hor:wishlist:v1';
  var Wish = {
    items: [],
    load: function () {
      try { this.items = JSON.parse(localStorage.getItem(KEY)) || []; }
      catch (e) { this.items = []; }
    },
    save: function () { try { localStorage.setItem(KEY, JSON.stringify(this.items)); } catch (e) {} },
    has: function (pid) {
      return this.items.some(function (i) { return String(i.pid) === String(pid); });
    },
    toggle: function (item) {
      if (this.has(item.pid)) {
        this.items = this.items.filter(function (i) { return String(i.pid) !== String(item.pid); });
        toast('Removed from wishlist');
        this.save(); this.render(); this.syncHearts();
      } else {
        this.items.unshift(item);
        this.save(); this.render(); this.syncHearts();
        Overlay.open('wish');          /* show them what they just saved */
      }
    },
    remove: function (pid) {
      this.items = this.items.filter(function (i) { return String(i.pid) !== String(pid); });
      this.save(); this.render(); this.syncHearts();
    },
    syncHearts: function () {
      var self = this;
      $$('[data-hor-wish]').forEach(function (b) {
        b.setAttribute('aria-pressed', self.has(b.dataset.horWish) ? 'true' : 'false');
      });
      var dot = $('#hor-wish-dot');
      if (dot) dot.style.display = self.items.length ? 'block' : 'none';
      $$('[data-hor-wcount]').forEach(function (b) {
        b.textContent = self.items.length;
        b.style.display = self.items.length ? 'grid' : 'none';
      });
    },
    render: function () {
      var g = $('#hor-wish-grid');
      if (!g) return;
      g.innerHTML = this.items.length ? this.items.map(function (i) {
        return '<div class="hor-wc">' +
          '<a href="' + esc(i.url) + '">' +
            (i.img ? '<img src="' + cdn(i.img, 500) + '" alt="" width="250" height="313" loading="lazy" decoding="async">' : ph(250, 313)) +
          '</a>' +
          '<button type="button" class="hor-wc__x" data-hor-unwish="' + esc(i.pid) + '" aria-label="Remove">' +
            '<svg class="hor-i" viewBox="0 0 24 24"><path d="M12 19.9c-.3 0-.5-.1-.7-.2C7.6 16.9 4.3 14 4.3 10.4A4.1 4.1 0 0 1 12 8.1a4.1 4.1 0 0 1 7.7 2.3c0 3.6-3.3 6.5-7 9.3-.2.1-.4.2-.7.2Z"/></svg>' +
          '</button>' +
          '<div class="hor-wc__b"><div class="hor-wc__t">' + esc(i.title) + '</div>' +
          '<div class="hor-wc__r"><span class="hor-wc__pr">' + money(i.price) + '</span>' +
          '<button type="button" class="hor-wc__add" data-hor-add="' + esc(i.vid) + '" aria-label="Add to cart">+</button>' +
          '</div></div></div>';
      }).join('') : '<div class="hor-empty">Nothing saved yet.<br>Tap the heart on any piece.</div>';
    }
  };

  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-hor-wish]');
    if (w) {
      e.preventDefault();
      Wish.toggle({
        pid: w.dataset.horWish, vid: w.dataset.horVid, title: w.dataset.horTitle,
        price: parseInt(w.dataset.horPrice, 10), img: w.dataset.horImg, url: w.dataset.horUrl
      });
      return;
    }
    var u = e.target.closest('[data-hor-unwish]');
    if (u) Wish.remove(u.dataset.horUnwish);
  });

  /* ── collection: pills auto-scroll, description show-more ── */
  function collection() {
    /* bring the active pill into view without jumping the page */
    var pills = $('.hor-pills');
    if (pills) {
      var here = $('.is-here', pills);
      if (here) {
        var l = here.offsetLeft, r = l + here.offsetWidth;
        /* leave the list alone unless the active pill is off screen —
           scrolling it always would eat the left inset */
        if (l < pills.scrollLeft || r > pills.scrollLeft + pills.clientWidth) {
          pills.scrollTo({ left: Math.max(0, l - 16), behavior: 'auto' });
        }
      }
    }

    /* description show more — hidden when the text already fits */
    $$('[data-hor-clamp]').forEach(function (w) {
      var inner = $('.hor-coll__desc-in', w), btn = $('[data-hor-more]', w);
      if (!inner || !btn) return;
      requestAnimationFrame(function () {
        if (inner.scrollHeight <= inner.clientHeight + 4) {
          btn.hidden = true;
          w.classList.add('is-open');
        }
      });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hor-more]');
    if (!b) return;
    var w = b.closest('[data-hor-clamp]');
    var open = w.classList.toggle('is-open');
    b.textContent = open ? b.dataset.less : b.dataset.more;
  });

  /* ─────────────────────────────────────────────────────────
     INFINITE SCROLL — fetches the next page, lifts out the grid
     items and appends them. Falls back to a button when set.
     ───────────────────────────────────────────────────────── */
  function infinite() {
    var wrap = $('[data-hor-more-wrap]');
    var grid = $('#product-grid');
    if (!wrap || !grid) return;
    var busy = false;

    function load() {
      var next = wrap.dataset.next;
      if (!next || busy) return;
      busy = true;
      wrap.innerHTML = '<span class="hor-more__s" aria-hidden="true"></span>';

      fetch(next, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('#product-grid > li');
          Array.prototype.forEach.call(items, function (li) {
            grid.appendChild(document.importNode(li, true));
          });
          var nw = doc.querySelector('[data-hor-more-wrap]');
          if (nw && nw.dataset.next) {
            wrap.dataset.next = nw.dataset.next;
            wrap.innerHTML = wrap.dataset.mode === 'button'
              ? '<button type="button" class="hor-more__b" data-hor-load>Load more</button>'
              : '<span class="hor-more__s" aria-hidden="true"></span>';
          } else {
            wrap.dataset.next = '';
            wrap.innerHTML = '<span class="hor-more__e">That\u2019s everything</span>';
            if (io) io.disconnect();
          }
          busy = false;
          Wish.syncHearts();          /* newly added cards need their state */
        })
        .catch(function () {
          busy = false;
          wrap.innerHTML = '<button type="button" class="hor-more__b" data-hor-load>Try again</button>';
        });
    }

    var io = null;
    if (wrap.dataset.mode !== 'button' && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) load();
      }, { rootMargin: '600px 0px' });
      io.observe(wrap);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-hor-load]')) load();
    });
  }

  /* ─────────────────────────────────────────────────────────
     HOUSE MEMORY
     Search, account, 404 and the cart page have no collection or
     product to resolve from, so they render neutral. Remember the
     last real house for the session and keep the skin consistent.
     ───────────────────────────────────────────────────────── */
  var HKEY = 'hor:house';
  function houseMemory() {
    var now = document.body.dataset.house;
    try {
      if (now && now !== 'house') {
        sessionStorage.setItem(HKEY, now);
        return;
      }
      var last = sessionStorage.getItem(HKEY);
      if (last && document.body.dataset.horNeutral !== 'lock') {
        document.body.dataset.house = last;
      }
    } catch (e) { /* private mode — the neutral skin is a fine fallback */ }
  }


  /* ─────────────────────────────────────────────────────────
     PRODUCT PAGE
     Gallery dots and thumbs, variant picker, quantity, the
     minimum-order nudge, sticky bar, zoom and share.
     Each step is isolated so one failure cannot kill the rest.
     ───────────────────────────────────────────────────────── */
  var PDP = {
    init: function () {
      ['gallery', 'variants', 'quantity', 'nudge', 'sticky', 'zoom', 'share', 'more', 'reviews']
        .forEach(function (k) {
          try { PDP[k](); } catch (e) { console.warn('[HOR] PDP.' + k, e); }
        });
    },

    gallery: function () {
      $$('.hor-gal').forEach(function (gal) {
        var track = $('[data-hor-gal-track]', gal);
        if (!track) return;
        var dots = $$('[data-hor-gal-dots] i', gal);
        var thumbs = $$('[data-hor-thumb]', gal);
        var counter = $('[data-hor-gal-current]', gal);
        var slides = $$('[data-hor-slide]', track);

        function activate(i) {
          dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
          thumbs.forEach(function (t, n) { t.classList.toggle('on', n === i); });
          if (counter) counter.textContent = i + 1;
        }

        if ('IntersectionObserver' in window && slides.length) {
          var io = new IntersectionObserver(function (en) {
            en.forEach(function (e) {
              if (e.isIntersecting) activate(slides.indexOf(e.target));
            });
          }, { root: track, threshold: 0.55 });
          slides.forEach(function (sl) { io.observe(sl); });
        }

        thumbs.forEach(function (t) {
          t.addEventListener('click', function () {
            var i = parseInt(t.dataset.horThumb, 10);
            var sl = slides[i];
            if (!sl) return;
            if (track.scrollWidth > track.clientWidth) {
              track.scrollTo({ left: sl.offsetLeft - track.offsetLeft, behavior: 'smooth' });
            } else {
              sl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            activate(i);
          });
        });
      });
    },

    variants: function () {
      var root = $('[data-hor-variants]');
      if (!root) return;
      var data;
      try { data = JSON.parse($('[data-hor-variant-data]', root).textContent); }
      catch (e) { return; }

      function chosen() {
        return $$('[data-hor-opt]', root).map(function (g) {
          var on = $('.hor-opt__b.on', g);
          return on ? on.dataset.horVal : null;
        });
      }
      function match(sel) {
        return data.find(function (v) {
          return sel.every(function (val, i) { return v.options[i] === val; });
        });
      }
      function paint() {
        var sel = chosen(), v = match(sel);

        $$('[data-hor-opt]', root).forEach(function (g, gi) {
          $$('.hor-opt__b', g).forEach(function (btn) {
            var test = sel.slice();
            test[gi] = btn.dataset.horVal;
            var cand = match(test);
            if (cand && cand.available) btn.removeAttribute('data-out');
            else btn.setAttribute('data-out', '');
          });
          var lbl = $('[data-hor-opt-label]', g);
          if (lbl) lbl.textContent = sel[gi] || '';
        });

        if (!v) return;
        var input = $('[data-hor-vid]');
        if (input) input.value = v.id;
        document.body.dataset.horUnit = v.price;
        $$('[data-hor-price-out]').forEach(function (el) { el.textContent = money(v.price); });

        var btn = $('[data-hor-submit]');
        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available ? (btn.dataset.on || 'Add to cart') : 'Sold out';
        }
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
        } catch (e) {}
        PDP.nudge();
      }

      root.addEventListener('click', function (e) {
        var b = e.target.closest('.hor-opt__b');
        if (!b) return;
        $$('.hor-opt__b', b.closest('[data-hor-opt]')).forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        paint();
      });
      paint();
    },

    quantity: function () {
      var val = $('[data-hor-qval]'), input = $('[data-hor-qty-input]');
      if (!val) return;
      document.addEventListener('click', function (e) {
        var b = e.target.closest('[data-hor-qstep]');
        if (!b) return;
        var n = Math.max(1, parseInt(val.textContent, 10) + parseInt(b.dataset.horQstep, 10));
        val.textContent = n;
        if (input) input.value = n;
        PDP.nudge();
      });
    },

    /* reads paise from a data attribute, never from the formatted string —
       "Rs. 499", "₹1,399" and "Rs 1.399,00" all parse differently */
    nudge: function () {
      var box = $('[data-hor-mov]');
      if (!box) return;
      var mov = parseInt(box.dataset.horMov, 10);
      var unit = parseInt(document.body.dataset.horUnit || '0', 10);
      if (!unit) return;
      var qty = parseInt(($('[data-hor-qval]') || {}).textContent || '1', 10);
      var line = unit * qty;
      var gap = mov - line;
      var t = $('[data-hor-mov-text]');
      if (!t) return;
      t.innerHTML = gap <= 0
        ? '\u2713 Minimum order reached'
        : 'Add ' + money(gap) + ' more to check out';
    },

    sticky: function () {
      var bar = $('[data-hor-stickybar]'), buy = $('.hor-pdp__buy');
      if (!bar || !buy) return;
      bar.hidden = false;

      /* when the inline block is hidden there is nothing to scroll past,
         so the bar simply stays up */
      if (buy.classList.contains('is-hidden')) {
        bar.classList.add('is-on');
      } else if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          bar.classList.toggle('is-on', !en[0].isIntersecting);
        }, { threshold: 0 }).observe(buy);
      } else {
        bar.classList.add('is-on');
      }

      var go = $('[data-hor-stick-add]');
      if (go) go.addEventListener('click', function () {
        var form = $('#hor-add-form');
        if (!form) return;
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    },

    zoom: function () {
      var z = $('#hor-zoom');
      if (!z) return;
      var body = $('[data-hor-zoom-body]', z);
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-hor-zoom]')) {
          var gal = e.target.closest('.hor-gal');
          var idx = 0;
          var on = gal && gal.querySelector('[data-hor-gal-dots] i.on');
          if (on) idx = Array.prototype.indexOf.call(on.parentNode.children, on);
          var th = gal && gal.querySelector('.hor-gal__th.on');
          if (th) idx = parseInt(th.dataset.horThumb, 10);
          var img = gal && (gal.querySelector('[data-hor-slide="' + idx + '"] img')
                            || gal.querySelector('img'));
          if (!img) return;
          body.innerHTML = '<img src="' + (img.currentSrc || img.src) + '" alt="">';
          z.classList.add('is-open');
          z.setAttribute('aria-hidden', 'false');
          Overlay.lock();
          return;
        }
        if (e.target.closest('[data-hor-zoom-close]') || e.target === z) {
          z.classList.remove('is-open');
          z.setAttribute('aria-hidden', 'true');
          Overlay.unlock();
          body.innerHTML = '';
        }
      });
    },

    share: function () {
      document.addEventListener('click', function (e) {
        var b = e.target.closest('[data-hor-share]');
        if (!b) return;
        var d = { title: b.dataset.title, url: b.dataset.url };
        if (navigator.share) { navigator.share(d).catch(function () {}); return; }
        if (navigator.clipboard) {
          navigator.clipboard.writeText(d.url).then(function () { toast('Link copied'); });
        }
      });
    },

    more: function () {
      document.addEventListener('click', function (e) {
        var b = e.target.closest('[data-hor-more]');
        if (!b) return;
        var w = b.closest('.hor-desc');
        var open = w.classList.toggle('is-open');
        b.textContent = open ? b.dataset.less : b.dataset.more;
      });
      /* hide the control when the text already fits */
      $$('.hor-desc[data-hor-clamp="true"]').forEach(function (w) {
        var inner = $('.hor-desc__in', w), btn = $('[data-hor-more]', w);
        if (!inner || !btn) return;
        requestAnimationFrame(function () {
          if (inner.scrollHeight <= inner.clientHeight + 4) {
            btn.hidden = true;
            w.classList.add('is-open');
          }
        });
      });
    },

    /* the rating scrolls to whatever section id you name in the setting —
       a Judge.me section, an accordion, anything with that id */
    reviews: function () {
      document.addEventListener('click', function (e) {
        var a = e.target.closest('[data-hor-scroll]');
        if (!a) return;
        var id = a.dataset.horScroll;
        if (!id) return;
        var t = document.getElementById(id) ||
                document.getElementById('shopify-section-' + id) ||
                document.querySelector('[id*="' + id + '"]');
        if (!t) return;
        e.preventDefault();
        if (t.tagName === 'DETAILS') t.open = true;
        var d = t.closest('details');
        if (d) d.open = true;
        var top = t.getBoundingClientRect().top + window.scrollY - 70;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    }
  };

  /* ─────────────────────────────────────────────────────────
     VIDEO CARDS
     Nothing is fetched on page load. A card that scrolls into view
     gets its source loaded and starts; a card that leaves pauses.
     Data Saver and reduced-motion opt out entirely.
     ───────────────────────────────────────────────────────── */
  function videoCards() {
    var cards = $$('[data-hor-video]');
    if (!cards.length) return;

    var save = navigator.connection && (navigator.connection.saveData ||
      /2g/.test(navigator.connection.effectiveType || ''));
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (save || still || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var wrap = e.target;
        var vid = wrap.querySelector('video');
        if (!vid) return;
        if (e.isIntersecting) {
          if (!vid.dataset.horReady) {
            vid.dataset.horReady = '1';
            vid.preload = 'auto';
            vid.load();
          }
          var play = vid.play();
          if (play && play.then) {
            play.then(function () { wrap.classList.add('is-playing'); })
                .catch(function () { /* autoplay refused — the poster stands in */ });
          } else {
            wrap.classList.add('is-playing');
          }
        } else {
          vid.pause();
        }
      });
    }, { rootMargin: '120px 0px', threshold: 0.35 });

    cards.forEach(function (c) { io.observe(c); });
  }

  /* ── boot: each step isolated so one failure cannot kill the rest ── */
  function boot() {
    [['house',    houseMemory],
     ['wishlist', function () { Wish.load(); Wish.render(); Wish.syncHearts(); }],
     ['cart',     function () { Cart.init(); }],
     ['overlay',  function () { Overlay.sync(); }],
     ['collection', collection],
     ['infinite',   infinite],
     ['pdp',        function () { PDP.init(); }],
     ['video',      videoCards]
    ].forEach(function (pair) {
      try { pair[1](); } catch (e) { console.warn('[HOR] boot.' + pair[0], e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);

  window.HOR = { Overlay: Overlay, Cart: Cart, Wish: Wish, PDP: PDP, toast: toast, money: money, cdn: cdn };
})();